import { useTranslation } from 'react-i18next'

import { Box, Text } from '@enechain/ecloud-designsystem'
import { FaWrenchRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

type Props = {
  /** アクティブなタブの表示ラベル (= t(periodTab.<key>) 済みの文字列) */
  tabLabel: string
}

/**
 * 開発中プレースホルダ (procurement-plan-list-period-tab 設計 Decision #4)。
 * 週間 / 月間 / 年間タブ選択時、フィルタ・アクションバー・テーブル領域を隠して
 * 同位置に表示する。
 *
 * 見た目は `pages/DemandForecastList/components/UnderDevPlaceholder` と揃える
 * (レンチ 40px + タイトル + 説明の同型パネル)。文言は plan/demand-suppression
 * 等の未実装ページで表示される PlaceholderPage の title (`common:placeholder.title`
 * = 「この画面は現在開発中です」) を共有し、description は本画面固有 (タブラベル
 * 併記) を page.json に置く。**共通 `~/components/common/` への昇格は別 issue で
 * 扱う** — 2 画面が別々のタイトル文言を採る (DemandForecastList = 画面名込みの動的
 * タイトル / 本画面 = 共通の固定タイトル) ため、単純な共通化では props が肥大する。
 */
export const UnderDevPlaceholder = ({
  tabLabel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Box
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={3}
      display="flex"
      textAlign="center"
      borderWidth="1px"
      borderColor="Border.lowEmphasis"
      borderRadius="lg"
      backgroundColor="Surface.primary"
      paddingX={4}
      paddingY={8}
    >
      {/* パネル装飾 icon (36px = iconSize.decorative)。DemandForecastList の
          同型 UnderDevPlaceholder は design HTML (`#dfl-under-dev`) 由来の 40px を
          px 直書き禁止の一時免除で持つ。ここでは新規 allowlist を増やさず、共通定数
          `iconSize.decorative` (dropzone 等の面装飾 icon 36px) を使う。 */}
      <FaWrenchRegular
        boxSize={iconSize.decorative}
        color="Text.midEmphasis"
        aria-hidden="true"
      />
      <Text textStyle="sectionTitle" color="Text.highEmphasis">
        {t('common:placeholder.title')}
      </Text>
      <Text color="Text.midEmphasis">
        {t('page:procurementPlanList.periodTab.underDevDescription', {
          tabLabel,
        })}
      </Text>
    </Box>
  )
}
